export const products = [
  {
    id: 'p1',
    name: 'Midnight Ember',
    family: 'Woodsy',
    price: 34.00,
    notes: 'Smoked Cedar, Black Pepper, Vetiver',
    description: 'A deep, meditative scent that captures the essence of a dying fire in a winter forest. Hand-poured into our signature smoke-tinted glass.',
    image: 'https://images.unsplash.com/photo-1605651202774-7d573fd3f12d?auto=format&fit=crop&q=80&w=600',
    isNew: true,
    stock: 12,
  },
  {
    id: 'p2',
    name: 'Velvet Vetiver',
    family: 'Earthy',
    price: 32.00,
    notes: 'Earth, Damp Moss, Crushed Leaves',
    description: 'The scent of a garden after a heavy rain. Fresh, green, and deeply grounding with a clean mineral finish.',
    image: 'https://images.unsplash.com/photo-1596433809252-260c27459eb4?auto=format&fit=crop&q=80&w=600',
    stock: 5,
  },
  {
    id: 'p3',
    name: 'Smoked Vanilla',
    family: 'Sweet',
    price: 30.00,
    notes: 'Bourbon Vanilla, Charred Oak, Amber',
    description: 'Not your typical sweet vanilla. This is sophisticated, smoky, and dangerously addictive with notes of barrel-aged spirits.',
    image: 'https://images.unsplash.com/photo-1620189507195-68309c04c4d0?auto=format&fit=crop&q=80&w=600',
    bestseller: true,
    stock: 24,
  },
  {
    id: 'p4',
    name: 'Autumn Fig',
    family: 'Fruity',
    price: 36.00,
    notes: 'Ripe Fig, Cassis, Dark Woods',
    description: 'A sophisticated fruit scent balanced by the bitterness of cassis and deep wood notes. Perfect for transitional evenings.',
    image: 'https://images.unsplash.com/photo-1602874801007-bd458cb6c975?auto=format&fit=crop&q=80&w=600',
    stock: 0, // Out of stock
  },
  {
    id: 'p5',
    name: 'Bergamot Noir',
    family: 'Citrus',
    price: 34.00,
    notes: 'Black Tea, Bergamot, Leather',
    description: 'Bright citrus notes grounded by the richness of black tea and worn leather. An intellectual, uplifting fragrance.',
    image: 'https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?auto=format&fit=crop&q=80&w=600',
    stock: 18,
  },
  {
    id: 'p6',
    name: 'Leather & Amber',
    family: 'Woodsy',
    price: 38.00,
    notes: 'Worn Leather, Warm Amber, Musk',
    description: 'Evokes the feeling of an old library with high ceilings and leather-bound books. Rich, warm, and timeless.',
    image: 'https://images.unsplash.com/photo-1608181114410-db2aa03d7d8a?auto=format&fit=crop&q=80&w=600',
    bestseller: true,
    stock: 9,
  }
];

export const reviews = [
  {
    id: 1,
    author: "Elena V.",
    rating: 5,
    text: "Midnight Ember is the most sophisticated candle I've ever owned. The scent throw is incredible without being overwhelming.",
    product: "Midnight Ember"
  },
  {
    id: 2,
    author: "Julian R.",
    rating: 5,
    text: "The packaging alone is a work of art. Smoked Vanilla has become my signature home scent. Truly exceptional quality.",
    product: "Smoked Vanilla"
  },
  {
    id: 3,
    author: "Sarah M.",
    rating: 4,
    text: "The burn is so clean. I followed the burn guide and my candle is lasting much longer than other luxury brands.",
    product: "Velvet Vetiver"
  }
];

export const faqData = [
  {
    question: "What kind of wax do you use?",
    answer: "We use a proprietary blend of organic coconut and apricot wax. It provides a clean, slow burn and excellent scent throw without the soot associated with paraffin."
  },
  {
    question: "How long do your candles burn?",
    answer: "Our standard 8oz candles offer approximately 45-50 hours of burn time when cared for properly according to our burn guide."
  },
  {
    question: "Are your fragrances safe?",
    answer: "Yes. We use premium, phthalate-free fragrance oils infused with essential oils. All our products are cruelty-free and non-toxic."
  },
  {
    question: "What is your return policy?",
    answer: "We accept returns on unused, unlit candles within 14 days of delivery. Please contact our support team to initiate a return."
  }
];